// PersonModal.jsx (fixed overlay & constrained height)
// Replace your existing PersonModal.jsx with this content (adjust imports path as needed)

import React, { useEffect, useState, useRef } from "react";
import { customEncode, authFetch } from "../DecryptData"; // adjust path if needed

function PersonModal({ person, onClose }) {
  const [form, setForm] = useState({
    VoterFullName: "",
    Address: "",
    CardNo: "",
    MobileNumber: "",
    EmailId: "",
    Caste: "",
    Shifted: "No",
    Category: "General",
    LastTimeCastedVote: "Yes",
    Reason: "",
    FavourModiji: 5,
    Influencer: 5,
    Qualification: "",
    Occupation: "",
  });

  const [allCastes, setAllCastes] = useState([]);
  const modalRef = useRef(null);

  useEffect(() => {
    if (!person) return;

    setForm({
      VoterFullName:
        `${person.esurname || ""} ${person.name_english || ""} ${person.relative_english || ""}`
          .replace(/\s+/g, " ")
          .trim(),
      Address: person.address || "",
      CardNo: person.CardNo || person.cardno || "",
      MobileNumber: person.mobile || person.MobileNumber || "",
      EmailId: person.CandidateMobile1 || person.EmailId || "",
      Caste: person.Caste || "",
      Shifted: person.Shifted || "No",
      Category: person.Category || "General",
      LastTimeCastedVote: person.LastTimeCastedVote || "Yes",
      Reason: person.Reason || "",
      FavourModiji: person.FavourModiji || 5,
      Influencer: person.Influencer || 5,
      Qualification: person.Qualification || "",
      Occupation: person.Occupation || "",
    });

    if (person.constno) {
      authFetch("http://anuplights.in:8083/apisecure/GetAllCastesByconstno", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: customEncode(JSON.stringify({ ConstNo: person.constno })),
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) setAllCastes(data);
          else if (Array.isArray(data?.data)) setAllCastes(data.data);
          else setAllCastes([]);
        })
        .catch(() => setAllCastes([]));
    } else {
      setAllCastes([]);
    }
  }, [person]);

  const updateField = (key, val) => {
    setForm((prev) => ({ ...prev, [key]: val }));
  };

  if (!person) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalWrapStyle}>
        <div style={modalStyle} ref={modalRef} role="dialog" aria-modal="true" aria-label="Person Details">
          <div style={headerStyle}>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <h2 style={titleStyle}>Person Details</h2>
              <div style={{ fontSize: 12, color: "#666" }}>
                {person.constno ? `Const: ${person.constno}` : null}
              </div>
            </div>
            <button style={closeIconStyle} onClick={onClose} aria-label="Close">✕</button>
          </div>

          <div style={modalBodyStyle}>
            {/* compact grid */}
            <div style={formGridStyle}>
              <div style={pairStyle}>
                <div style={pairItemStyle}>
                  <label style={labelStyle}>Full Name</label>
                  <input value={form.VoterFullName} disabled style={{ ...inputStyle, ...inputDisabled }} />
                </div>

                <div style={{ ...pairItemStyle, maxWidth: 170 }}>
                  <label style={labelStyle}>Mobile</label>
                  <input
                    value={form.MobileNumber}
                    onChange={(e) => updateField("MobileNumber", e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>

              <div style={fullRowStyle}>
                <label style={labelStyle}>Address</label>
                <input value={form.Address} onChange={(e) => updateField("Address", e.target.value)} style={inputStyle} />
              </div>

              <div style={pairStyle}>
                <div style={{ ...pairItemStyle, maxWidth: 220 }}>
                  <label style={labelStyle}>Card No</label>
                  <input value={form.CardNo} disabled style={{ ...inputStyle, ...inputDisabled }} />
                </div>

                <div style={pairItemStyle}>
                  <label style={labelStyle}>Email</label>
                  <input value={form.EmailId} onChange={(e) => updateField("EmailId", e.target.value)} style={inputStyle} />
                </div>
              </div>

              <div style={pairStyle}>
                <div style={{ ...pairItemStyle, maxWidth: 200 }}>
                  <label style={labelStyle}>Caste</label>
                  <select value={form.Caste} onChange={(e) => updateField("Caste", e.target.value)} style={inputStyle}>
                    <option value="">Select</option>
                    {Array.isArray(allCastes) && allCastes.map((c, idx) => <option key={idx}>{c.CasteName}</option>)}
                  </select>
                </div>

                <div style={pairItemStyle}>
                  <label style={labelStyle}>Category</label>
                  <select value={form.Category} onChange={(e) => updateField("Category", e.target.value)} style={inputStyle}>
                    <option>General</option>
                    <option>SC</option>
                    <option>ST</option>
                    <option>OBC</option>
                    <option>EWS</option>
                  </select>
                </div>
              </div>

              <div style={pairStyle}>
                <div style={pairItemStyle}>
                  <label style={labelStyle}>Shifted</label>
                  <select value={form.Shifted} onChange={(e) => updateField("Shifted", e.target.value)} style={inputStyle}>
                    <option>No</option>
                    <option>Yes</option>
                  </select>
                </div>

                <div style={pairItemStyle}>
                  <label style={labelStyle}>Last Voted</label>
                  <select value={form.LastTimeCastedVote} onChange={(e) => updateField("LastTimeCastedVote", e.target.value)} style={inputStyle}>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
              </div>

              <div style={pairStyle}>
                <div style={pairItemStyle}>
                  <label style={labelSmallStyle}>Favour Modiji</label>
                  <input type="number" min="1" max="10" value={form.FavourModiji} onChange={(e) => updateField("FavourModiji", Number(e.target.value))} style={{ ...inputStyle, textAlign: "center" }} />
                </div>

                <div style={pairItemStyle}>
                  <label style={labelSmallStyle}>Influencer</label>
                  <input type="number" min="1" max="10" value={form.Influencer} onChange={(e) => updateField("Influencer", Number(e.target.value))} style={{ ...inputStyle, textAlign: "center" }} />
                </div>
              </div>

              <div style={pairStyle}>
                <div style={pairItemStyle}>
                  <label style={labelStyle}>Qualification</label>
                  <input value={form.Qualification} onChange={(e) => updateField("Qualification", e.target.value)} style={inputStyle} />
                </div>

                <div style={pairItemStyle}>
                  <label style={labelStyle}>Occupation</label>
                  <input value={form.Occupation} onChange={(e) => updateField("Occupation", e.target.value)} style={inputStyle} />
                </div>
              </div>
            </div>
          </div>

          <div style={footerStyle}>
            <button style={smallButtonStyle} onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
}

/* Styles used above */
const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 99999,
  padding: 12,
};

const modalWrapStyle = {
  width: "min(820px, 96vw)",
  maxHeight: "90vh",
  display: "flex",
  flexDirection: "column",
};

const modalStyle = {
  background: "#fff",
  borderRadius: 8,
  boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  maxHeight: "90vh",
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "8px 10px",
  borderBottom: "1px solid #eee",
};

const titleStyle = {
  margin: 0,
  fontSize: 15,
  fontWeight: 700,
};

const closeIconStyle = {
  background: "#333",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  padding: "6px 8px",
  cursor: "pointer",
  fontSize: 13,
};

const modalBodyStyle = {
  padding: 8,
  overflow: "auto", // inner scroll
  flex: 1,
};

const formGridStyle = {
  display: "grid",
  gap: 8,
};

const fullRowStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 6,
};

const pairStyle = {
  display: "flex",
  gap: 8,
};

const pairItemStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

const labelStyle = {
  fontSize: 11,
  marginBottom: 2,
  fontWeight: 600,
};

const labelSmallStyle = {
  fontSize: 10,
  marginBottom: 2,
  fontWeight: 700,
};

const inputStyle = {
  padding: "6px 8px",
  borderRadius: 6,
  border: "1px solid #ddd",
  fontSize: 13,
  height: 32,
  boxSizing: "border-box",
};

const inputDisabled = {
  background: "#f6f6f6",
  color: "#444",
};

const footerStyle = {
  padding: "8px 10px",
  borderTop: "1px solid #eee",
  display: "flex",
  justifyContent: "flex-end",
};

const smallButtonStyle = {
  padding: "6px 10px",
  background: "#333",
  color: "#fff",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  fontSize: 13,
  height: 34,
};

export default PersonModal;
